<header class="clients-screen-header">
  <!-- Figma "Clients Subheader": Back to Clients on the left (on a sub-page), the section tabs
       centred, and an empty right column the same width so the tabs sit dead centre. -->
  <nav class="clients-screen-subnav" aria-label="Clients screen navigation">
    <div class="clients-subnav-side">
      @if (clientsWorkspaceSection() !== 'list') {
      <button type="button" class="clients-subnav-back" (click)="setClientsWorkspaceSection('list')">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.5 17 9.5 12l5-5"></path></svg>
        Back to Clients
      </button>
      }
    </div>
    <div class="clients-subnav-tabs">
      <button type="button" class="clients-subnav-link" [class.clients-subnav-link--active]="clientsWorkspaceSection() === 'schedule'"
        (click)="setClientsWorkspaceSection('schedule')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M10 2h4M12 14l3-3"></path><circle cx="12" cy="14" r="8"></circle></svg>
        {{ getCustomLabel('Schedule') }}
      </button>
      <button type="button" class="clients-subnav-link" [class.clients-subnav-link--active]="clientsWorkspaceSection() === 'communication'"
        (click)="setClientsWorkspaceSection('communication')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M21 12a9 9 0 0 1-13.4 7.9L3 21l1.1-4.6A9 9 0 1 1 21 12z"></path><path d="M8 12h8"></path></svg>
        {{ getCustomLabel('Communication') }}
      </button>
      <button type="button" class="clients-subnav-link" [class.clients-subnav-link--active]="clientsWorkspaceSection() === 'submissions'"
        (click)="setClientsWorkspaceSection('submissions')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <rect x="3" y="3" width="18" height="18" rx="4"></rect><path d="M12 16V8M8.5 11.5 12 8l3.5 3.5"></path></svg>
        Submissions
        <span class="nav-beta-pill nav-beta-pill--gradient" aria-hidden="true">Beta</span>
      </button>
      <button type="button" class="clients-subnav-link" [class.clients-subnav-link--active]="clientsWorkspaceSection() === 'letters'"
        (click)="setClientsWorkspaceSection('letters')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M8 2v3M16 2v3"></path><rect x="4" y="3.5" width="16" height="18.5" rx="2"></rect><path d="M8 11h8M8 15.5h5"></path></svg>
        Letters
      </button>
      <button type="button" class="clients-subnav-link" [class.clients-subnav-link--active]="clientsWorkspaceSection() === 'aml'"
        (click)="setClientsWorkspaceSection('aml')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path><path d="m9 12 2 2 4-4"></path></svg>
        AML
      </button>
    </div>
    <div class="clients-subnav-side" aria-hidden="true"></div>
  </nav>
</header>
